import React, { PureComponent } from 'react';
import { Marker} from 'react-leaflet';

class SearchMarker extends PureComponent {
  render() {
    const { data } = this.props;

    if (!data) {
      return null;
    }

    const icon = L.divIcon({
      className: 'map-label search-marker',
      iconSize: [30, 14],
      iconAnchor: [15, 7],
      html: data.rank
    });

    return (
      <Marker
        position={data.position}
        icon={icon}
      />
    );
  }
}

export default SearchMarker;
